export default "__VITE_ASSET__lyqKdqLe__"